import * as React from 'react'
import AdvancedAlertModalContainer from '../AlertModals/AdvancedAlertModal/AdvancedAlertModalContainer'
import BasicAlertModalContainer from '../AlertModals/BasicAlertModal/BasicAlertModalContainer'
import NewAlertDropdown from '../NewAlertDropdown/NewAlertDropdown'
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip'
import * as labels from '@mulesoft/monitoring-center-components/lib/utils/labels'
import { AlertsSvg } from './AlertsSvg'
import './AlertLandingPage.css'

export type ValueProps = {
  isTitanium: boolean
  hasEditRole?: boolean
  isBasicAlertsEnabled: boolean
  isAPIBasicAlertsEnabled: boolean
  isBasicAlertsLimitExceeded: boolean
  organizationDomain: string
}

export type EventProps = {
  handleOpenBasicAlertModal: () => void
  handleOpenAdvancedAlertModal: () => void
}

export type Props = ValueProps & EventProps

export default class AlertsLandingPage extends React.Component<Props> {

    getNewAlertDropdownProps() {
    const {isTitanium, isBasicAlertsEnabled, isBasicAlertsLimitExceeded, organizationDomain,
      handleOpenBasicAlertModal, handleOpenAdvancedAlertModal} = this.props

    return {
      isTitanium: isTitanium,
      isLandingPage: true,
      isBasicAlertsEnabled: isBasicAlertsEnabled,
      organizationDomain: organizationDomain,
      disabled: !this.props.hasEditRole,
      handleOpenBasicAlertModal: handleOpenBasicAlertModal,
      handleOpenAdvancedAlertModal: handleOpenAdvancedAlertModal
    }
  }

  render() {
    const {isBasicAlertsEnabled, hasEditRole, isAPIBasicAlertsEnabled} = this.props
    const newAlertDropdownProps = this.getNewAlertDropdownProps()
    const newAlertDropdown = hasEditRole ? <NewAlertDropdown {...newAlertDropdownProps}/> :
      <Tooltip content={labels.missingAlertPermissions} position={'bottom'} offset={[0, 5]}>
        <NewAlertDropdown {...newAlertDropdownProps}/>
      </Tooltip>

    return (
      <div className={'alerts-landing-page-container'}>
        <div className={'alert-landing-page-header'}>
          <span className={'alerts-landing-page-title'}>Anypoint Monitoring Alerts</span>
          <span className={'alerts-landing-page-subtitle'}>
              Track trends and create alerts to identify abnormal behavior.
          </span>
        </div>
        <div className={'alert-landing-page-button'}>
          {newAlertDropdown}
        </div>
        <div className={'alert-landing-page-image'}>
          <AlertsSvg/>
        </div>
        {isBasicAlertsEnabled && <BasicAlertModalContainer/>}
        <AdvancedAlertModalContainer/>
      </div>
    )
  }

}
